<template>
    <b-navbar toggleable="md" fixed="true" class="navbar-default">
        <router-link :to="homeLink">
            <b-navbar-brand>
                <img :src="img.logo" :alt="$t('navbar.logoAlt')" class="navbar-logo">
            </b-navbar-brand>
        </router-link>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item href="#" :to="homeLink">{{ $t('navbar.dashboard') }}</b-nav-item>
                <b-nav-item href="#" :to="{name: 'reports'}" v-if="isStaff">{{ $t('navbar.reports') }}</b-nav-item>

                <b-nav-item-dropdown right>
                    <template v-slot:button-content>
                        <b-avatar variant="primary" :text="userInitials" size="2rem" class="my-user-avatar"></b-avatar>
                        <span class="px-2">{{ userName }}</span>
                    </template>
                    <b-dropdown-item href="#" @click="logOutUser">{{ $t('navbar.logout') }}</b-dropdown-item>
                </b-nav-item-dropdown>

                <LocaleSwitcher @change="$emit('localeChange', $event)"></LocaleSwitcher>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
    // utils
    import logo from '../../assets/img/Montazhi_EAD_logo.svg';
    import {AUTH_LOGOUT} from "../../store/actions/auth";
    import {USER_REQUEST} from "../../store/actions/user";
    import {mapGetters} from "vuex";
    // components
    import LocaleSwitcher from "./LocaleSwitcher";

    /**
     * Navigation bar. Has logo that needs to be switched on/off.
     * Contains locale switcher, has user avatar and name.
     * Handles logout.
     *
     * Programmer notes:
     * https://bootstrap-vue.org/docs/reference/router-links - BSV integrates router links
     */

    export default {
        name: "Navbar",
        components: {
            LocaleSwitcher
        },
        data() {
            return {
                img: {
                    logo
                }
            }
        },
        mounted() {
            const profile = this.getProfile;
            if (!profile['username']) {
                this.$store.dispatch(USER_REQUEST);
            }
        },
        methods: {
            logOutUser() {
                this.$store.dispatch(AUTH_LOGOUT)
                    .then(() => {
                        this.$router.push("/login");
                    })
                    .catch(() => {
                        this.$router.push("/login");
                    });
            }
        },
        computed: {
            ...mapGetters(['getProfile', 'isStaff']),
            userInitials() {
                const DEFAULT_INITIALS = 'U';
                const profile = this.getProfile;
                if (!(profile['first_name'] || profile['last_name'] )) {
                    return DEFAULT_INITIALS;
                } else {
                    const parts = [profile['first_name'], profile['last_name'] ];
                    let initials = '';

                    for (let i = 0; i < parts.length; i++) {
                        if (parts[i].length > 0 && parts[i] !== '') {
                            initials += parts[i][0]
                        }
                    }
                    return initials;
                }
            },
            userName() {
                const DEFAULT_USERNAME = 'User';
                const profile = this.getProfile;
                return profile['username'] || DEFAULT_USERNAME;
            },
            homeLink() {
                let backToObj = {name: 'dashboard'};
                if (this.$route.params.id) {
                    backToObj['params'] = {id: this.$route.params.id}
                }
                return backToObj;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    /* change color for navbar */
    .navbar.navbar-default {
        background-color: transparent;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.051);
        border: none;
        opacity: 1;
        z-index: 2;
        border-bottom: 1px solid rgba(0, 0, 0, 0.051);
    }
    .navbar-logo {
        max-width: 11.25rem; //180px
    }

     /*hamburger*/
    .navbar-default .navbar-toggler {
        border: none;
        outline: none;
    }

    /* ***************************************************** */

     /*override bootstrap arrow (chevron) and use custom one*/


    /*.navbar-default .container-fluid .navbar-collapse {*/
    /*    background: #FFFFFF 0% 0% no-repeat padding-box;*/
    /*}*/

    /* ---------- Menus padding and border-right --------- */

    /* border-right for each nav item */
    .navbar.navbar-default {
        .navbar-nav {
            .nav-item {
                font: 400 1rem Nunito, sans-serif;
                padding-right: 1rem;
                padding-left: 1rem;
                &:not(:last-child) {
                    border-right: 1px solid $lightGrey;
                }
                .nav-link {
                    &:focus {
                        outline: none;
                    }
                    &:hover {
                        color: $menuBlue !important;
                    }
                    > span:hover {
                        color: $menuBlue !important;
                    }
                    /* style active item */
                    &.router-link-exact-active.router-link-active {
                        font: 600 1rem Nunito, sans-serif;
                        color: $menuBlue;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .my-user-avatar {
        background-color: $shadow;
        color: $menuBlue;
        font: 700 16px Nunito, sans-serif;
    }

    @media screen and (min-width: 769px) {
        .navbar.navbar-default {
            height: 70px;
            .navbar-nav {
                /* this item is already flexed */
                align-items: center;
            }
        }
    }


    @media screen and (max-width: 768px) {
        .navbar.navbar-default {
            .navbar-nav {
                .nav-item {
                    display: flex;
                    align-items: center;
                    height: 3.5rem;
                    &:not(:last-child) {
                        border-bottom: 1px solid $lightGrey;
                        border-right: none;
                    }
                }
            }
        }
    }


    /*  background: $menuBlue;
        background: linear-gradient(0deg, rgba(98,153,235,1) 0%, rgba(98,153,235,0.25) 9%, rgba(98,153,235,0) 100%);
    */


    /* ---------- active link --------- */
    /*.navbar-nav.navbar-right li.active a,*/
    /*.navbar-nav.navbar-right li.active a:hover {*/
    /*    text-align: center;*/
    /*    font: 600 16px/40px Nunito, sans-serif;*/
    /*    letter-spacing: 0;*/
    /*    color: #6299EB;*/
    /*    opacity: 1;*/
    /*}*/
</style>